export default function wpaType12(KIND, CATE, SCENE, DEPLOY, POSITION) {
    return {
        1: {
            kind: KIND[1],
            cate: CATE[12],
            type: 1,
            scene: SCENE[0],
            required: ['btnText', 'role', 'deployList'],
            role: ['roleWX'],
            theme: ['#ffffff', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
            defaults: {
                btnText: '扫码咨询',
                middlePage: {
                    pc: 0,
                    mobile: 1,
                },
                deployList: [
                    {
                        deployTypeId: DEPLOY[1],
                        deployRemarks: '',
                        deployWebsite: '',
                    },
                ],
            },
            limit: {
                btnText: 4,
            },
            size: {
                w: 96,
                h: 30,
            },
        },
        2: {
            kind: KIND[1],
            cate: CATE[12],
            type: 2,
            scene: SCENE[0],
            required: ['btnText', 'role', 'deployList'],
            role: ['roleWX'],
            theme: ['#ffffff', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
            defaults: {
                btnText: '扫码咨询',
                middlePage: {
                    pc: 0,
                    mobile: 1,
                },
                deployList: [
                    {
                        deployTypeId: DEPLOY[1],
                        deployRemarks: '',
                        deployWebsite: '',
                    },
                ],
            },
            limit: {
                btnText: 4,
            },
            size: {
                w: 150,
                h: 45,
            },
        },
        3: {
            kind: KIND[1],
            cate: CATE[12],
            type: 3,
            order: 3,
            scene: SCENE[0],
            defaultPosition: POSITION[6],
            required: [
                'title',
                'signature',
                'role',
                'avatar',
                'location',
                'deployList',
            ],
            avatarType: 2,
            role: ['roleWX'],
            defaults: {
                title: '微信咨询',
                signature: '服务时间 9:00-20:00',
                location: {
                    v: {
                        type: 2,
                        px: 0,
                    },
                    h: {
                        type: 3,
                        px: 0,
                    },
                },
                middlePage: {
                    pc: 0,
                    mobile: 1,
                },
                deployList: [
                    {
                        deployTypeId: DEPLOY[1],
                        deployRemarks: '',
                        deployWebsite: '',
                    },
                ],
            },
            limit: {
                title: 5,
                signature: 10,
            },
            size: {
                w: 255,
                h: 85,
            },
            iconTip: '，此处二维码仅示意，生成后可扫码咨询',
        },
        4: {
            kind: KIND[1],
            cate: CATE[12],
            type: 4,
            order: 1,
            scene: SCENE[0],
            defaultPosition: POSITION[6],
            required: ['btnText', 'role', 'location', 'deployList'],
            role: ['roleWX'],
            defaults: {
                btnText: '扫码咨询',
                location: {
                    v: {
                        type: 2,
                        px: 0,
                    },
                    h: {
                        type: 3,
                        px: 10,
                    },
                },
                middlePage: {
                    pc: 0,
                    mobile: 1,
                },
                deployList: [
                    {
                        deployTypeId: DEPLOY[1],
                        deployRemarks: '',
                        deployWebsite: '',
                    },
                ],
            },
            limit: {
                btnText: 4,
            },
            posHint: 1,
            size: {
                w: 70,
                h: 70,
            },
        },
        5: {
            kind: KIND[1],
            cate: CATE[12],
            type: 5,
            order: 5,
            scene: SCENE[0],
            defaultPosition: POSITION[6],
            required: [
                'title',
                'avatar',
                'btnText',
                'role',
                'location',
                'deployList',
            ],
            avatarType: 1,
            role: ['roleWX'],
            btnBgColor: ['#56CB6C', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
            defaults: {
                title: '扫码咨询',
                btnText: '微信交谈',
                location: {
                    v: {
                        type: 2,
                        px: 0,
                    },
                    h: {
                        type: 3,
                        px: 10,
                    },
                },
                middlePage: {
                    pc: 0,
                    mobile: 1,
                },
                deployList: [
                    {
                        deployTypeId: DEPLOY[1],
                        deployRemarks: '',
                        deployWebsite: '',
                    },
                ],
            },
            limit: {
                btnText: 4,
                title: 6,
            },
            posHint: 1,
            size: {
                w: 106,
                h: 165,
            },
            iconTip: '，此处二维码仅示意，生成后可扫码咨询',
        },
        7: {
            kind: KIND[1],
            cate: CATE[12],
            type: 7,
            order: 3,
            scene: SCENE[2],
            defaultPosition: POSITION[9],
            required: ['role', 'location', 'deployList'],
            role: ['roleWX'],
            pos: 'rb',
            defaults: {
                location: {
                    v: {
                        type: 3,
                        px: 20,
                    },
                    h: {
                        type: 3,
                        px: 15,
                    },
                },
                middlePage: {
                    pc: 0,
                    mobile: 1,
                },
                deployList: [
                    {
                        deployTypeId: DEPLOY[2],
                        deployRemarks: '',
                        deployWebsite: '',
                    },
                ],
            },
            size: {
                w: 48,
                h: 48,
            },
        },
        8: {
            kind: KIND[1],
            cate: CATE[12],
            type: 8,
            order: 4,
            scene: SCENE[2],
            defaultPosition: POSITION[9],
            required: ['role', 'location', 'deployList'],
            role: ['roleWX'],
            pos: 'rb',
            defaults: {
                location: {
                    v: {
                        type: 3,
                        px: 20,
                    },
                    h: {
                        type: 3,
                        px: 15,
                    },
                },
                middlePage: {
                    pc: 0,
                    mobile: 1,
                },
                deployList: [
                    {
                        deployTypeId: DEPLOY[2],
                        deployRemarks: '',
                        deployWebsite: '',
                    },
                ],
            },
            size: {
                w: 125,
                h: 39,
            },
        },
        9: {
            kind: KIND[1],
            cate: CATE[12],
            type: 9,
            order: 5,
            scene: SCENE[2],
            defaultPosition: POSITION[8],
            required: [
                'title',
                'signature',
                'theme',
                'position',
                'avatar',
                'role',
                'location',
                'deployList',
            ],
            avatarType: 1,
            theme: ['', '#000000', '#F6F7FA'],
            role: ['roleWX'],
            tpl: 3,
            tplOptions: {
                iconList: ['icon-wechat'],
                eventList: ['openImUrl'],
                hasAvatar: 1,
                fixedBtnText: '点击咨询',
            },
            defaults: {
                title: '咨询顾问',
                signature: '欢迎随时与我们联系',
                theme: 3,
                location: {
                    v: {
                        type: 3,
                        px: 0,
                    },
                    h: {
                        type: 1,
                        px: 0,
                    },
                },
                middlePage: {
                    pc: 0,
                    mobile: 1,
                },
                deployList: [
                    {
                        deployTypeId: DEPLOY[2],
                        deployRemarks: '',
                        deployWebsite: '',
                    },
                ],
            },
            limit: {
                signature: 10,
                title: 8,
            },
            size: {
                w: '100%',
                h: 65,
            },
            iconTip: '此处头像仅示意，生成组件后将展示实际客服形象',
        },
        10: {
            kind: KIND[1],
            cate: CATE[12],
            type: 10,
            order: 6,
            scene: SCENE[2],
            defaultPosition: POSITION[8],
            required: ['title', 'signature', 'theme', 'position', 'role', 'location', 'deployList'],
            theme: ['', '#000000', '#F6F7FA'],
            role: ['roleWX'],
            tpl: 3,
            tplOptions: {
                iconList: ['icon-wechat'],
                eventList: ['openImUrl'],
                fixedBtnText: '点击咨询',
                hasAvatar: 0,
            },
            defaults: {
                title: '咨询顾问',
                signature: '欢迎随时与我们联系',
                theme: 3,
                location: {
                    v: {
                        type: 3,
                        px: 0,
                    },
                    h: {
                        type: 1,
                        px: 0,
                    },
                },
                middlePage: {
                    pc: 0,
                    mobile: 1,
                },
                deployList: [
                    {
                        deployTypeId: DEPLOY[2],
                        deployRemarks: '',
                        deployWebsite: '',
                    },
                ],
            },
            limit: {
                signature: 10,
                title: 8,
            },
            size: {
                w: '100%',
                h: 65,
            },
        },
        15: {
            kind: KIND[1],
            cate: CATE[12],
            type: 15,
            scene: SCENE[0],
            required: [
                'title',
                'signature',
                'avatar',
                'role',
                'deployList',
                'location',
            ],
            isQRcode: 1,
            avatarType: 2,
            theme: ['#ffffff'],
            role: ['roleWX'],
            defaultPosition: POSITION[6],
            defaults: {
                title: '扫码咨询顾问',
                signature: '扫描二维码进行咨询，随时了解最新动态。',
                location: {
                    v: {
                        type: 2,
                        px: 0,
                    },
                    h: {
                        type: 3,
                        px: 0,
                    },
                },
                deployList: [
                    {
                        deployTypeId: DEPLOY[1],
                        deployRemarks: '',
                        deployWebsite: '',
                    },
                ],
            },
            limit: {
                signature: 26,
                title: 8,
            },
            suitable: 'wx',
            size: {
                w: 350,
                h: 138,
            },
            iconTip: '，此处二维码仅示意，生成后可扫码咨询',
        },
        17: {
            kind: KIND[1],
            cate: CATE[12],
            type: 17,
            order: 2,
            scene: SCENE[0],
            required: ['custom', 'role', 'deployList'],
            role: ['roleWX'],
            defaults: {
                btnText: '在线咨询',
                custom: {
                    customType: 2, // 1 - 自定义DOM 2 - 自定义图片
                    domId: '', // 自定义DOM ID
                    open: 1, // 1 - 当前页打开 2 - 新窗口打开
                    customImg: {
                        zoom: 0, // 0 - 不适应 1 - 水平适应 2 - 上下适应
                        url: '',
                        h: {
                            type: 3, // 1 - 左 2 - 中 3 - 右
                            px: 0, // 偏移量
                        },
                        v: {
                            type: 3, // 1 - 上 2 - 中 3 - 下
                            px: 0, // 偏移量
                        },
                        width: 0,
                        height: 0,
                    },
                },
                middlePage: {
                    pc: 0,
                    mobile: 1,
                },
                deployList: [
                    {
                        deployTypeId: DEPLOY[1],
                        deployRemarks: '',
                        deployWebsite: '',
                    },
                ],
            },
        },
        18: {
            kind: KIND[1],
            cate: CATE[12],
            type: 18,
            order: 2,
            scene: SCENE[2],
            required: ['custom', 'role', 'deployList'],
            role: ['roleWX'],
            defaults: {
                btnText: '在线咨询',
                custom: {
                    customType: 2, // 1 - 自定义DOM 2 - 自定义图片
                    domId: '', // 自定义DOM ID
                    open: 1, // 1 - 当前页打开 2 - 新窗口打开
                    customImg: {
                        zoom: 0, // 0 - 不适应 1 - 水平适应 2 - 上下适应
                        url: '',
                        h: {
                            type: 3, // 1 - 左 2 - 中 3 - 右
                            px: 0, // 偏移量
                        },
                        v: {
                            type: 3, // 1 - 上 2 - 中 3 - 下
                            px: 0, // 偏移量
                        },
                        width: 0,
                        height: 0,
                    },
                },
                middlePage: {
                    pc: 0,
                    mobile: 1,
                },
                deployList: [
                    {
                        deployTypeId: DEPLOY[2],
                        deployRemarks: '',
                        deployWebsite: '',
                    },
                ],
            },
        },
        20: {
            kind: KIND[1],
            cate: CATE[12],
            type: 20,
            order: 1,
            scene: SCENE[2],
            defaultPosition: POSITION[6],
            required: ['role', 'location', 'deployList'],
            theme: ['#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
            avatarType: 2,
            role: ['roleWX'],
            defaults: {
                title: '',
                signature: '',
                location: {
                    v: {
                        type: 3,
                        px: 20,
                    },
                    h: {
                        type: 3,
                        px: 15,
                    },
                },
                middlePage: {
                    pc: 0,
                    mobile: 1,
                },
                deployList: [
                    {
                        deployTypeId: DEPLOY[2],
                        deployRemarks: '',
                        deployWebsite: '',
                    },
                ],
            },
            limit: {
                title: 5,
                signature: 10,
            },
            size: {
                w: 60,
                h: 60,
            },
        },
    };
}
